import React from "react";
import QBuilt from ".";

function QBuiltComponent({ comp, params }) {
    return <QBuilt screen={comp.subtype} params={params} />;
}

export default QBuiltComponent;
